(function () {
  'use strict';

  const UPSELL_SELECTOR = '[data-upsell-add]';
  const OPTION_SELECTOR = '[data-upsell-option]';

  document.addEventListener('click', handleUpsellClick);
  document.addEventListener('change', handleVariantChange);


  /*
   * =========================================================
   * VARIANT SELECTION
   * =========================================================
   */

  function handleVariantChange(event) {

    const select = event.target.closest(OPTION_SELECTOR);

    if (!select) return;

    const upsellItem = select.closest('[data-upsell-item]');

    if (!upsellItem) return;

    updateSelectedVariant(upsellItem);
  }


  /*
   * Find matching Shopify variant
   */

  function updateSelectedVariant(upsellItem) {

    const variantsElement =
      upsellItem.querySelector('[data-upsell-variants]');

    const selects =
      upsellItem.querySelectorAll('[data-upsell-option]');

    const button =
      upsellItem.querySelector('[data-upsell-add]');

    const priceElement =
      upsellItem.querySelector('[data-upsell-price]');

    if (
      !variantsElement ||
      !button ||
      !selects.length
    ) {
      return;
    }

    let variants;

    try {
      variants = JSON.parse(
        variantsElement.textContent
      );
    } catch (error) {

      console.error(
        '[Cart Upsell] Unable to parse variants:',
        error
      );

      return;
    }


    /*
     * Get selected option values
     */

    const selectedOptions = Array.from(selects)
      .sort(function (a, b) {
        return (
          Number(a.dataset.optionPosition) -
          Number(b.dataset.optionPosition)
        );
      })
      .map(function (select) {
        return select.value;
      });


    /*
     * Find exact matching variant
     */

    const matchedVariant = variants.find(
      function (variant) {

        if (
          !variant.options ||
          variant.options.length !==
            selectedOptions.length
        ) {
          return false;
        }

        return variant.options.every(
          function (optionValue, index) {
            return (
              optionValue ===
              selectedOptions[index]
            );
          }
        );
      }
    );


    /*
     * No matching variant
     */

    if (!matchedVariant) {

      button.dataset.variantId = '';

      button.disabled = true;

      button.classList.add(
        'is-sold-out'
      );

      const textElement =
        button.querySelector(
          '[data-upsell-add-text]'
        );

      if (textElement) {
        textElement.textContent =
          'SOLD OUT';
      }

      return;
    }


    /*
     * Save actual variant ID
     */

    button.dataset.variantId =
      matchedVariant.id;


    /*
     * Update price
     */

    if (
      priceElement &&
      typeof Shopify !== 'undefined' &&
      typeof Shopify.formatMoney === 'function'
    ) {

      priceElement.textContent =
        Shopify.formatMoney(
          matchedVariant.price,
          window.moneyFormat ||
          '{{ shop.money_format | escape }}'
        );
    }


    /*
     * Available / sold out
     */

    if (matchedVariant.available) {

      button.disabled = false;

      button.classList.remove(
        'is-sold-out'
      );

      const textElement =
        button.querySelector(
          '[data-upsell-add-text]'
        );

      if (textElement) {
        textElement.textContent =
          'ADD';
      }

    } else {

      button.disabled = true;

      button.classList.add(
        'is-sold-out'
      );

      const textElement =
        button.querySelector(
          '[data-upsell-add-text]'
        );

      if (textElement) {
        textElement.textContent =
          'SOLD OUT';
      }
    }
  }


  /*
   * =========================================================
   * ADD TO CART
   * =========================================================
   */

  async function handleUpsellClick(event) {

    const button =
      event.target.closest(
        UPSELL_SELECTOR
      );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();


    /*
     * Prevent duplicate clicks
     */

    if (
      button.disabled ||
      button.classList.contains('is-loading') ||
      button.classList.contains('is-added')
    ) {
      return;
    }


    /*
     * IMPORTANT:
     * This is now the selected variant ID.
     */

    const variantId =
      button.dataset.variantId;


    if (!variantId) {

      console.error(
        '[Cart Upsell] Missing selected variant ID.'
      );

      return;
    }


    setLoading(button, true);


    try {

      /*
       * Add selected variant to Shopify cart
       */

      const addUrl =
        KROWN.settings.routes.cart_add_url +
        '.js';


      const response =
        await fetch(
          addUrl,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/x-www-form-urlencoded; charset=UTF-8',

              'X-Requested-With':
                'XMLHttpRequest',

              'Accept':
                'application/json'
            },

            body:
              'id=' +
              encodeURIComponent(variantId) +
              '&quantity=1'
          }
        );


      const data =
        await response.json();


      if (
        !response.ok ||
        data.status >= 400
      ) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product to cart.'
        );
      }


      /*
       * Refresh cart UI
       */

     await setLastAddedVariant(variantId);
await refreshCart();


      /*
       * Show Added!
       */

      setAdded(button);


      /*
       * Open cart drawer
       */

      openCartSidebar();


    } catch (error) {

      console.error(
        '[Cart Upsell] Add to cart error:',
        error
      );

      setError(button);
    }
  }
async function setLastAddedVariant(variantId) {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        last_added_variant_id: String(variantId)
      }
    })
  });

  if (!response.ok) {
    throw new Error(
      'Unable to save last added variant.'
    );
  }

  return response.json();
}
  /*
   * =========================================================
   * REFRESH CART
   * =========================================================
   */

  async function refreshCart() {

    const response =
      await fetch(
        '?section_id=cart-helper',
        {
          method: 'GET',

          headers: {
            'Accept': 'text/html'
          },

          cache: 'no-store'
        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to refresh cart helper.'
      );
    }


    const html =
      await response.text();


    const doc =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );


    const newCartForm =
      doc.getElementById(
        'AjaxCartForm'
      );


    const currentCartForm =
      document.getElementById(
        'AjaxCartForm'
      );


    if (
      !newCartForm ||
      !currentCartForm
    ) {

      throw new Error(
        'AjaxCartForm not found.'
      );
    }


    /*
     * Replace cart contents
     */

    currentCartForm.innerHTML =
      newCartForm.innerHTML;


    /*
     * Reinitialize cart item interactions
     */

    if (
      typeof currentCartForm
        .ajaxifyCartItems ===
      'function'
    ) {

      currentCartForm.ajaxifyCartItems();
    }


    /*
     * Update subtotal
     */

    const newCartSubtotal =
      doc.getElementById(
        'AjaxCartSubtotal'
      );


    const currentCartSubtotal =
      document.getElementById(
        'AjaxCartSubtotal'
      );


    if (
      newCartSubtotal &&
      currentCartSubtotal
    ) {

      currentCartSubtotal.innerHTML =
        newCartSubtotal.innerHTML;
    }


    /*
     * Update header cart count
     */

    updateCartCount(
      newCartForm
    );


    /*
     * Reload images
     */

    if (
      typeof window.preloadImages ===
      'function'
    ) {

      window.preloadImages(
        currentCartForm
      );
    }


    /*
     * Notify other scripts
     */

    document.dispatchEvent(
      new CustomEvent(
        'cart:upsell-added',
        {
          detail: {
            source: 'upsell'
          }
        }
      )
    );
  }


  /*
   * =========================================================
   * CART COUNT
   * =========================================================
   */

  function updateCartCount(
    cartForm
  ) {

    const newCartCount =
      cartForm.querySelector(
        '[data-cart-count]'
      );


    if (!newCartCount) return;


    const headerCartCount =
      document.querySelector(
        '[data-header-cart-count]'
      );


    if (headerCartCount) {

      headerCartCount.textContent =
        newCartCount.textContent;
    }


    const cartCountElements =
      document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble'
      );


    cartCountElements.forEach(
      function (element) {

        if (
          element ===
          newCartCount
        ) {
          return;
        }


        const text =
          newCartCount.textContent.trim();


        if (!text) return;


        const count =
          element.querySelector(
            '[aria-hidden="true"]'
          );


        if (count) {

          count.textContent =
            text;
        }
      }
    );
  }


  /*
   * =========================================================
   * OPEN CART SIDEBAR
   * =========================================================
   */

  function openCartSidebar() {

    const cartSidebar =
      document.getElementById(
        'site-cart-sidebar'
      );


    if (
      cartSidebar &&
      typeof cartSidebar.show ===
      'function'
    ) {

      cartSidebar.show();

      return;
    }


    if (
      cartSidebar &&
      typeof cartSidebar.open ===
      'function'
    ) {

      cartSidebar.open();
    }
  }


  /*
   * =========================================================
   * LOADING
   * =========================================================
   */

  function setLoading(
    button,
    loading
  ) {

    button.disabled =
      loading;


    button.classList.toggle(
      'is-loading',
      loading
    );


    button.setAttribute(
      'aria-busy',
      loading
        ? 'true'
        : 'false'
    );
  }


  /*
   * =========================================================
   * ADDED
   * =========================================================
   */

  function setAdded(
    button
  ) {

    button.classList.remove(
      'is-loading',
      'is-error'
    );


    button.classList.add(
      'is-added'
    );


    button.disabled =
      true;


    button.setAttribute(
      'aria-busy',
      'false'
    );


    const textElement =
      button.querySelector(
        '[data-upsell-add-text]'
      );


    if (textElement) {

      textElement.textContent =
        'Added!';
    }
  }


  /*
   * =========================================================
   * ERROR
   * =========================================================
   */

  function setError(
    button
  ) {

    button.classList.remove(
      'is-loading'
    );


    button.classList.add(
      'is-error'
    );


    button.disabled =
      false;


    button.setAttribute(
      'aria-busy',
      'false'
    );


    const textElement =
      button.querySelector(
        '[data-upsell-add-text]'
      );


    if (textElement) {

      textElement.textContent =
        'ADD';
    }


    setTimeout(
      function () {

        button.classList.remove(
          'is-error'
        );

      },
      2000
    );
  }

})();